import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Box, Flex } from "orcs-design-system";
import { PanelIconButton } from "./PanelIconButton";

export const PanelLine = ({
  children,
  centered,
  canEdit,
  canSave,
  isEditing,
  isSaving,
  onEdit,
  onSave,
  onCancel,
}) => {
  const onEditClick = useCallback(() => {
    if (canEdit) {
      onEdit?.();
    }
  }, [canEdit, onEdit]);

  const onCancelClick = useCallback(() => {
    onCancel?.();
  }, [onCancel]);

  const onSaveClick = useCallback(() => {
    if (canSave) {
      onSave?.();
    }
  }, [canSave, onSave]);

  const renderButtons = () => {
    if (!canEdit) {
      return null;
    }

    if (isSaving) {
      return <PanelIconButton type="loading" onClick={() => {}} />;
    }

    if (isEditing) {
      if (centered) {
        return (
          <Flex flexDirection="column" gap="s">
            <PanelIconButton type="cancel" onClick={onCancelClick} />
            <PanelIconButton
              type="approve"
              onClick={onSaveClick}
              disabled={!canEdit || !canSave}
            />
          </Flex>
        );
      }

      return (
        <Flex flexDirection="row" gap="s">
          <PanelIconButton
            type="approve"
            onClick={onSaveClick}
            disabled={!canEdit || !canSave}
          />
          <PanelIconButton type="cancel" onClick={onCancelClick} />
        </Flex>
      );
    }

    return <PanelIconButton type="edit" onClick={onEditClick} />;
  };

  // centered
  if (centered) {
    return (
      <Flex
        width="100%"
        flexDirection="row"
        justifyContent="center"
        alignItems="flex-start"
        px="xl"
        position="relative"
      >
        {children}
        <Box position="absolute" top="0" right="0">
          {renderButtons()}
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      width="100%"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      {children}
      {renderButtons()}
    </Flex>
  );
};

PanelLine.propTypes = {
  children: PropTypes.node,
  centered: PropTypes.bool,
  canEdit: PropTypes.bool,
  canSave: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSaving: PropTypes.bool,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};
